import React from "react";
import AplicativoPaciente from "assets/app-paciente/svg/App_paciente.svg";
import PacienteProntlife from "assets/app-paciente/svg/Paciente_prontlife.svg";
import { SectionInfo } from "components/card/SectionCard";
import { Image } from "components/commons/Image";
import { ComputadorDesktopIcon } from "components/icons/ComputadorDesktopIcon";
import { ComputadorIcon } from "components/icons/ComputadorIcon";
import { FrequenciaCardiacaIcon } from "components/icons/FrequenciaCardiacaIcon";
import { IphoneIcon } from "components/icons/IphoneIcon";
import { AplicativoMobileTabs } from "./components/AplicativoMobileTabs";
import { AplicativosCards } from "./components/AplicativosCards";
import { AplicativosDownloadSection } from "./components/AplicativosDownloadSection";
import { AplicativosHeaderText } from "./components/AplicativosHeaderText";
import { AplicativosInformationContent } from "./components/AplicativosInformationContent";
import { AplicativosTabs } from "./components/AplicativosTabs";

export const AplicativosPage = () => {
  return (
    <div>
      <section className="container mt-5">
        <SectionInfo
          leftComponent={<AplicativosHeaderText />}
          rightComponent={
            <Image source={PacienteProntlife} className={"image"} />
          }
        />
        <SectionInfo
          alignContentRightItem={"align-self-start"}
          alignContentLeftItem={"align-self-start"}
          leftComponent={
            <AplicativosInformationContent
              icon={
                <ComputadorDesktopIcon className={"aplicativos-page__icon"} />
              }
              title={"Profissionais de Saúde e Pacientes Integrados"}
              content={
                "Dados clínicos, exames, prescrições e orientações compartilhados entre você e seu médico em um único prontuário online."
              }
            />
          }
          rightComponent={
            <AplicativosInformationContent
              icon={<ComputadorIcon className={"aplicativos-page__icon"} />}
              title={"Compartilhamentos de Dados"}
              content={
                "O ProntLife permite que você compartilhe suas informações com sua equipe médica ou em uma Emergência: chega de perder prescrições e sacolas de exames"
              }
            />
          }
        />
        <SectionInfo
          alignContentRightItem={"align-self-start"}
          alignContentLeftItem={"align-self-start"}
          leftComponent={
            <AplicativosInformationContent
              icon={
                <FrequenciaCardiacaIcon className={"aplicativos-page__icon"} />
              }
              title={"Monitore suas Medidas"}
              content={
                "Registre e acompanhe seus dados clínicos como Pressão Arterial, Glicose, Temperatura, Peso, IMC e muito mais!"
              }
            />
          }
          rightComponent={
            <AplicativosInformationContent
              icon={<IphoneIcon className={"aplicativos-page__icon"} />}
              title={"Sua Saúde em Suas Mãos"}
              content={
                "Acesse seus dados clínicos e faça avaliação de sintomas e queixas, como Triagem de Coronavírus"
              }
            />
          }
        />
        <SectionInfo
          leftComponent={
            <Image source={AplicativoPaciente} className={"image"} />
          }
          rightComponent={<AplicativosDownloadSection />}
          alignContentLeftItem={"align-self-center"}
        />
      </section>
      <AplicativosCards />
      <section className="container" style={{ marginTop: "6em" }}>
        <div className="row d-none d-md-block">
          <AplicativosTabs />
        </div>
        <AplicativoMobileTabs />
      </section>
    </div>
  );
};
